import React from 'react';
import Slider from 'react-slick';
import { useNavigate } from 'react-router-dom';


import './style.scss';
import { ascSort } from '@common/helpers/declarative/sortings';
import { getBannerImageUrl, getIsBannerVideo } from '@app/dev/helpers/banners';

import MediaSlideArrow from './arrow';

const MediaSliderRemote = ({ slides }) => {
  const navigate = useNavigate();

  if (!slides?.length) return null;

  const onNavigate = (redirectUrl) => {
    if (!redirectUrl) return;
    if (redirectUrl.startsWith('http')) {
      window.open(redirectUrl, '_self');
    } else {
      navigate(redirectUrl);
    }
  };

  const sliderContent = slides.sort(ascSort('index')).map((slide, index) => {
    const isVideo = getIsBannerVideo(slide.link || '');

    return (
      <div
        key={index}
        className="media-item"
        onClick={() => onNavigate(slide.redirectUrl)}
        style={{ cursor: slide.redirectUrl ? 'pointer' : 'default' }}
      >
        {isVideo ? (
          <video src={getBannerImageUrl(slide.link)} style={{ width: '100%', height: '100%', objectFit: 'cover' }} autoPlay loop muted playsInline />
        ) : (
          <img src={getBannerImageUrl(slide.link)} alt={slide.text || ''} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        )}
        {slide.text && <h3>{slide.text}</h3>}
        {slide.subText && <p>{slide.subText}</p>}
      </div>
    );
  });

  return (
    <div className="home-media-slider home-media-slider-remote">
      <Slider
        dots={sliderContent.length > 1}
        accessibility={false}
        arrows={sliderContent.length > 1}
        nextArrow={<MediaSlideArrow direction="right" />}
        prevArrow={<MediaSlideArrow direction="left" />}
        autoplay
        infinite={sliderContent.length > 1}
        draggable={slides.length > 1}
        autoplaySpeed={8000}
        dragging={false}
        slidesToShow={1}
        slidesToScroll={1}
      >
        {sliderContent}
      </Slider>
    </div>
  );
};

export default MediaSliderRemote;
